module.exports = __webpack_public_path__ + "static/media/label-exp.739d2105.png";